import React from 'react';
import { Modal, Select, Form, Row, Col, Button } from 'antd';
import { metadataFields } from './utils/helper';

interface SearchModalProps {
    visible: boolean;
    onClose: () => void;
    onSave: () => void;
    form: any; // Antd form instance
}

const SearchModal: React.FC<SearchModalProps> = ({
    visible,
    onClose,
    onSave,
    form,
}) => {
    const getFieldValue = (fieldName: string) => {
        const value = form.getFieldValue(['search_metadata', fieldName]);
        return value;
    };

    const getDisplayValue = (fieldName: string) => {
        console.log('Field Name:', fieldName, 'Value:', getFieldValue(fieldName)); // Debugging line
        const value = getFieldValue(fieldName);
        if (value === null || value === undefined) {
            form.setFieldValue(['search_metadata', fieldName], []); // Set to empty array if null/undefined
        }
        return value;
    };

    return (
        <>
            <style>{`
                .disabled-field-with-values .ant-select-disabled.ant-select .ant-select-selection-item {
                    color: #1890ff !important;
                    background-color: #e6f7ff !important;
                    border: 1px solid #91d5ff !important;
                }
                .disabled-field-with-values .ant-select-disabled.ant-select .ant-select-selector {
                    color: #1890ff !important;
                }
                .disabled-field-no-data .ant-select-disabled.ant-select .ant-select-selection-placeholder {
                    color: #d9d9d9 !important;
                }
            `}</style>
            <Modal
                title="Store Metadata"
                visible={visible} // 'visible' is deprecated, using 'open' for newer Antd versions
                onOk={onSave}
                onCancel={onClose}
                width={900}
                footer={[
                    <Button key="back" onClick={onClose}>
                        Cancel
                    </Button>,
                    <Button key="submit" type="primary" onClick={onSave}>
                        Save
                    </Button>,
                ]}
            >
                <div style={{ maxHeight: '60vh', overflowY: 'auto', padding: '0 16px' }}>
                    <label style={{ marginBottom: '8px', display: 'block', fontWeight: 'bold' }}>Search Metadata</label>
                    <Form form={form} layout="vertical" style={{ border: '1px solid #f2f2f2', padding: '16px', borderRadius: '8px' }}>
                        <Row gutter={24}>
                            {metadataFields.map((field) => {
                                const fieldValue = getFieldValue(field.name);
                                const isNoData = fieldValue === null || fieldValue === undefined || (Array.isArray(fieldValue) && fieldValue.length === 0);
                                const hasValues = !isNoData;

                                return (
                                    <Col span={12} key={field.name}>
                                        <Form.Item
                                            name={["search_metadata", field.name]}
                                            label={field.label}
                                        >
                                            <div className={hasValues ? 'disabled-field-with-values' : 'disabled-field-no-data'}>
                                                <Select
                                                    mode="multiple"
                                                    disabled
                                                    allowClear
                                                    placeholder={isNoData ? "No data available" : undefined}
                                                    value={getDisplayValue(field.name)}
                                                    style={{
                                                        width: '100%',
                                                    }}
                                                />
                                            </div>
                                        </Form.Item>
                                    </Col>
                                );
                            })}
                        </Row>
                    </Form>
                </div>
            </Modal>
        </>
    );
};

export default SearchModal;